import { gql } from 'graphql-tag';
import { type IdVerificationEligibilityQuery } from 'src/app/shared/graphql/identity-verification/id-verification-eligibility-query.graphql.autogenerated';

export type IdVerificationEligibilityQueryResult = IdVerificationEligibilityQuery['eligibleForIdentityVerification'];

export const IdVerificationEligibilityDocument = gql`
  query idVerificationEligibility {
    eligibleForIdentityVerification {
      eligible
      mandatory
    }
  }
`;
